import { Http } from "../axios/interceptors";

export const allTicketsSupport = async (param) =>
  Http("GET", `/TicketsSupport/GetList?`, param);

export const getTicketSupport = async (idSupplier) =>
  Http("GET", `/TicketsSupport/Get?idSupplier=${idSupplier}`);

export const createOrEditTicketSupport = async (body, id = null) =>
  id
    ? Http("PUT", `/TicketsSupport/Update`, null, body)
    : Http("POST", "/TicketsSupport/Create", null, body);

export const deleteTicketSupport= async (idTicketsSupport) =>
  Http("DELETE", `/TicketsSupport/Delete?idTicketsSupport=${idTicketsSupport}`);
